import React from 'react';
import { Sparkles, ExternalLink, X } from 'lucide-react';

interface CraftingTeaserProps {
  variant?: 'banner' | 'card' | 'inline';
  onDismiss?: () => void;
  showDismiss?: boolean;
}

export function CraftingTeaser({
  variant = 'banner',
  onDismiss,
  showDismiss = true,
}: CraftingTeaserProps) {
  const craftingUrl = 'https://goodwork-crafting.web.app';

  if (variant === 'inline') {
    return (
      <div className="flex items-center gap-2 text-sm text-gray-600">
        <Sparkles className="w-4 h-4 text-indigo-500" />
        <span>
          Für bessere Empfehlungen:{' '}
          <a
            href={craftingUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-indigo-600 font-medium hover:underline"
          >
            Crafting-Profil erstellen
          </a>
          <span className="text-gray-400 ml-1">(dein Account ist bereits verknüpft)</span>
        </span>
      </div>
    );
  }

  if (variant === 'card') {
    return (
      <div className="bg-gradient-to-r from-indigo-50 to-purple-50 border border-indigo-100 rounded-xl p-4">
        <div className="flex items-start gap-3">
          <div className="p-2 bg-indigo-100 rounded-lg flex-shrink-0">
            <Sparkles className="w-5 h-5 text-indigo-600" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-semibold text-gray-800 mb-1">
              Personalisierte Empfehlungen
            </h3>
            <p className="text-sm text-gray-600 mb-2">
              Erstelle dein Crafting-Profil und erhalte Ort-Vorschläge,
              die zu deiner Persönlichkeit passen.
            </p>
            <p className="text-xs text-gray-500 mb-3">
              Dein GoodPlace Account funktioniert automatisch – kein neues Login nötig.
            </p>
            <a
              href={craftingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-indigo-600 hover:text-indigo-800"
            >
              Profil erstellen
              <ExternalLink className="w-4 h-4" />
            </a>
          </div>
          {showDismiss && onDismiss && (
            <button
              onClick={onDismiss}
              className="p-1 text-gray-400 hover:text-gray-600 rounded flex-shrink-0"
            >
              <X className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>
    );
  }

  // Default: banner variant
  return (
    <div className="bg-indigo-50 border-b border-indigo-100 px-4 py-3">
      <div className="max-w-4xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <Sparkles className="w-5 h-5 text-indigo-600 flex-shrink-0" />
          <p className="text-sm text-indigo-800">
            <span className="font-medium">Tipp:</span> Erstelle dein Crafting-Profil für personalisierte Empfehlungen.
            <span className="text-indigo-600 ml-1">(Account bereits verknüpft)</span>
          </p>
        </div>
        <div className="flex items-center gap-2">
          <a
            href={craftingUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-medium text-indigo-600 hover:text-indigo-800 whitespace-nowrap"
          >
            Jetzt erstellen
          </a>
          {showDismiss && onDismiss && (
            <button
              onClick={onDismiss}
              className="p-1 text-indigo-400 hover:text-indigo-600 rounded"
            >
              <X className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default CraftingTeaser;
